import state from './module-taxreturnsubmission-state';
import mutations from './module-taxreturnsubmission-mutations';
import actions from './module-taxreturnsubmission-actions';
import getters from './module-taxreturnsubmission-getters';
export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
